import { Modal } from '@mui/material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

type ConfirmDriverStatusModalProps = {
  open: boolean;
  isActivating: boolean;
  driverName?: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmDriverStatusModal = ({
  open,
  isActivating,
  driverName,
  isLoading = false,
  onClose,
  onConfirm,
}: ConfirmDriverStatusModalProps) => {
  const normalizedName = driverName?.trim();
  const nameSuffix = normalizedName ? ` ${normalizedName}` : '';
  const message = isActivating
    ? `Confirma que deseas activar el usuario${nameSuffix}`
    : `Confirma que deseas desactivar el usuario${nameSuffix}`;

  return (
    <Modal open={open} onClose={onClose}>
      <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
        <div className='flex flex-col p-6 gap-5 w-[420px] bg-white outline-none rounded-lg shadow-xl'>
          <h2 className='text-lg font-semibold text-gray-800'>Confirmar acción</h2>
          <p className='text-base text-gray-600'>{message}</p>
          <div className='flex gap-3 justify-end'>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={onClose}
              disabled={isLoading}
            >
              Cancelar
            </GlobalButton>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={onConfirm}
              disabled={isLoading}
            >
              Confirmar
            </GlobalButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDriverStatusModal;
